import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/home/Home';
import AboutDiocese from './pages/about/AboutDiocese';
import OurChurches from './pages/churches/OurChurches';
import OurInstitutions from './pages/institutions/OurInstitutions';
import OurDepartments from './pages/departments/OurDepartments';
import OurPublications from './pages/publications/OurPublications';
import ContactUs from './pages/contact/ContactUs';
import NewsAndResults from './pages/news/NewsAndResults';
import BishopOffice from './pages/about/BishopOffice';
import Administration from './pages/about/Administration';
import LightsOfDiocese from './pages/about/LightsOfDiocese';
import FormerBishops from './pages/about/lightsof/FormerBishops';
import History from './pages/about/History';
import Colleges from './pages/institutions/Colleges';
import Schools from './pages/institutions/Schools';
import AidedHigherSecondary from './pages/institutions/aidedInstitutions/AidedHigherSecondary';
import AidedHighSchools from './pages/institutions/aidedInstitutions/AidedHighSchools';
import AidedUpSchools from './pages/institutions/aidedInstitutions/AidedUpSchools';
import AidedLpSchools from './pages/institutions/aidedInstitutions/AidedLpSchools';
import UnaidedHigherSecondary from './pages/institutions/unaidedInstitutions/UnaidedHigherSecondary';
import UnaidedHighSchools from './pages/institutions/unaidedInstitutions/UnaidedHighSchools';
import UnaidedUpSchools from './pages/institutions/unaidedInstitutions/UnaidedUpSchools';
import UnaidedLpSchools from './pages/institutions/unaidedInstitutions/UnaidedLpSchools';
import Hospitals from './pages/institutions/Hospitals';
import RetreatCenter from './pages/institutions/RetreatCenter';
import BookShop from './pages/institutions/BookShop';
import ChildCare from './pages/institutions/ChildCare';
import SocialBoard from './pages/institutions/SocialBoard';
import Readings from './pages/publications/Readings';
import Presbyters from './pages/about/lightsof/Presbyters';
import Deacons from './pages/about/lightsof/Deacons';
import Evangelists from './pages/about/lightsof/Evangelists';
import ChurchWorkers from './pages/about/lightsof/ChurchWorkers';
import Deputation from './pages/about/lightsof/Deputation';
import PresbytersonStudy from './pages/about/lightsof/PresbytersonStudy';
import SeminaryStudents from './pages/about/lightsof/SeminaryStudents';
import RetiredPresbyters from './pages/about/lightsof/RetiredPresbyters';
import Missionaries from './pages/about/lightsof/Missionaries';
import RetiredEvangelists from './pages/about/lightsof/RetiredEvangelists';
import LiveStreaming from './pages/media/LiveStreaming';
import PhotoGallery from './pages/media/PhotoGallery';
import Sitemap from './pages/sitemap/Sitemap';
import Loader from './components/Loader';
import './App.css';

function AppContent() {
  const navigate = useNavigate();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Show smooth preloader on initial page load while fetching resources
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1200);

    return () => clearTimeout(timer);
  }, []);

  // Extract the current section from the URL pathname
  let currentSection = location.pathname.substring(1).toLowerCase() || 'home';

  // Fallback map for currentSection to maintain backward compatibility
  // Converts string formats like 'about diocese' to 'about-diocese'
  const setCurrentSection = (section) => {
    let route = section.toLowerCase().replace(/ /g, '-');
    navigate(`/${route}`);
  };

  // Dynamic Document Title and Meta updates for SEO & Smooth scroll to top
  useEffect(() => {
    window.scrollTo(0, 0);

    const routeTitles = {
      '/': 'CSI Malabar Diocese | Church of South India',
      '/home': 'Home | CSI Malabar Diocese',
      '/about': 'About Diocese | CSI Malabar Diocese',
      '/about-diocese': 'About Diocese | CSI Malabar Diocese',
      '/history': 'Diocesan History & Heritage | CSI Malabar Diocese',
      '/bishop': "Bishop's Office | CSI Malabar Diocese",
      '/council': 'Diocesan Administration & Council | CSI Malabar Diocese',
      '/admin': 'Diocesan Administration & Council | CSI Malabar Diocese',
      '/lights': 'Lights of Diocese | CSI Malabar Diocese',
      '/former-bishops': 'Former Bishops Archives | CSI Malabar Diocese',
      '/churches': 'Our Churches & Parishes | CSI Malabar Diocese',
      '/our-churches': 'Our Churches & Parishes | CSI Malabar Diocese',
      '/institutions': 'Educational & Medical Institutions | CSI Malabar Diocese',
      '/our-institutions': 'Educational & Medical Institutions | CSI Malabar Diocese',
      '/colleges': 'Diocesan Colleges | CSI Malabar Diocese',
      '/schools': 'Diocesan Schools | CSI Malabar Diocese',
      '/hospitals': 'CSI Mission Hospital | CSI Malabar Diocese',
      '/retreat': 'Santi Bhavan Retreat Centre | CSI Malabar Diocese',
      '/bookshop': 'Diocesan Book Shop | CSI Malabar Diocese',
      '/childcare': 'Child Care Projects | CSI Malabar Diocese',
      '/socialboard': 'Social Board Services | CSI Malabar Diocese',
      '/departments': 'Diocesan Departments & Ministries | CSI Malabar Diocese',
      '/our-departments': 'Diocesan Departments & Ministries | CSI Malabar Diocese',
      '/publications': 'Diocesan Publications | CSI Malabar Diocese',
      '/readings': 'Daily Readings & Lectionary | CSI Malabar Diocese',
      '/news': 'News & Announcements | CSI Malabar Diocese',
      '/events': 'Diocesan Events & Programs | CSI Malabar Diocese',
      '/live': 'Live Streaming & Video Ministry | CSI Malabar Diocese',
      '/gallery': 'Photo & Video Gallery | CSI Malabar Diocese',
      '/contact': 'Contact Us | CSI Malabar Diocese',
      '/contact-us': 'Contact Us | CSI Malabar Diocese',
      '/sitemap': 'Sitemap | CSI Malabar Diocese'
    };

    const matchedTitle = routeTitles[location.pathname.toLowerCase()] || 'CSI Malabar Diocese | Church of South India';
    document.title = matchedTitle;
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-background text-text-secondary selection:bg-primary/20 selection:text-primary">
      {/* Global Preloader */}
      <Loader isLoading={isLoading} />

      {/* =========================================================
          GLOBAL PREMIUM FLOATING NAVBAR (USED ACROSS EVERY PAGE)
      ========================================================= */}
      <Navbar activeSection={currentSection} onSelectSection={setCurrentSection} />

      {/* Main Page Content */}
      <main>
        <Routes>
          {/* About Section */}
          <Route path="/about" element={<AboutDiocese activeSection={currentSection} onSelectSection={setCurrentSection} />} />
          <Route path="/about-diocese" element={<AboutDiocese activeSection={currentSection} onSelectSection={setCurrentSection} />} />
          <Route path="/history" element={<History activeSection={currentSection} onSelectSection={setCurrentSection} />} />
          <Route path="/bishop" element={<BishopOffice activeSection={currentSection} onSelectSection={setCurrentSection} />} />
          <Route path="/council" element={<Administration activeSection={currentSection} onSelectSection={setCurrentSection} />} />
          <Route path="/admin" element={<Administration activeSection={currentSection} onSelectSection={setCurrentSection} />} />
          <Route path="/lights" element={<LightsOfDiocese activeSection={currentSection} onSelectSection={setCurrentSection} />} />
          <Route path="/pioneers" element={<FormerBishops activeSection={currentSection} onSelectSection={setCurrentSection} />} />
          <Route path="/former-bishops" element={<FormerBishops activeSection={currentSection} onSelectSection={setCurrentSection} />} />
          <Route path="/former-bishop" element={<FormerBishops activeSection={currentSection} onSelectSection={setCurrentSection} />} />

          {/* Lights of Diocese Subpages */}
          <Route path="/presbyters" element={<Presbyters activeSection={currentSection} onSelectSection={setCurrentSection} />} />
          <Route path="/deacons" element={<Deacons activeSection={currentSection} onSelectSection={setCurrentSection} />} />
          <Route path="/evangelists" element={<Evangelists activeSection={currentSection} onSelectSection={setCurrentSection} />} />
          <Route path="/church-workers" element={<ChurchWorkers activeSection={currentSection} onSelectSection={setCurrentSection} />} />
          <Route path="/deputation" element={<Deputation activeSection={currentSection} onSelectSection={setCurrentSection} />} />
          <Route path="/presbyters-on-study" element={<PresbytersonStudy activeSection={currentSection} onSelectSection={setCurrentSection} />} />
          <Route path="/seminary-students" element={<SeminaryStudents activeSection={currentSection} onSelectSection={setCurrentSection} />} />
          <Route path="/retired-presbyters" element={<RetiredPresbyters activeSection={currentSection} onSelectSection={setCurrentSection} />} />
          <Route path="/missionaries" element={<Missionaries activeSection={currentSection} onSelectSection={setCurrentSection} />} />
          <Route path="/retired-evangelists" element={<RetiredEvangelists activeSection={currentSection} onSelectSection={setCurrentSection} />} />

          {/* Churches */}
          <Route path="/churches" element={<OurChurches activeSection={currentSection} onSelectSection={setCurrentSection} />} />
          <Route path="/our-churches" element={<OurChurches activeSection={currentSection} onSelectSection={setCurrentSection} />} />
          <Route path="/church" element={<OurChurches activeSection={currentSection} onSelectSection={setCurrentSection} />} />

          {/* Institutions */}
          <Route path="/institutions" element={<OurInstitutions activeSection={currentSection} onSelectSection={setCurrentSection} />} />
          <Route path="/our-institutions" element={<OurInstitutions activeSection={currentSection} onSelectSection={setCurrentSection} />} />
          <Route path="/colleges" element={<Colleges activeSection={currentSection} onSelectSection={setCurrentSection} />} />
          <Route path="/schools" element={<Schools activeSection={currentSection} onSelectSection={setCurrentSection} />} />
          <Route path="/aided-higher-secondary" element={<AidedHigherSecondary activeSection={currentSection} onSelectSection={setCurrentSection} />} />
          <Route path="/aided-high-schools" element={<AidedHighSchools activeSection={currentSection} onSelectSection={setCurrentSection} />} />
          <Route path="/aided-up-schools" element={<AidedUpSchools activeSection={currentSection} onSelectSection={setCurrentSection} />} />
          <Route path="/aided-lp-schools" element={<AidedLpSchools activeSection={currentSection} onSelectSection={setCurrentSection} />} />
          <Route path="/unaided-higher-secondary" element={<UnaidedHigherSecondary activeSection={currentSection} onSelectSection={setCurrentSection} />} />
          <Route path="/unaided-high-schools" element={<UnaidedHighSchools activeSection={currentSection} onSelectSection={setCurrentSection} />} />
          <Route path="/unaided-up-schools" element={<UnaidedUpSchools activeSection={currentSection} onSelectSection={setCurrentSection} />} />
          <Route path="/unaided-lp-schools" element={<UnaidedLpSchools activeSection={currentSection} onSelectSection={setCurrentSection} />} />
          <Route path="/hospitals" element={<Hospitals activeSection={currentSection} onSelectSection={setCurrentSection} />} />
          <Route path="/retreat" element={<RetreatCenter activeSection={currentSection} onSelectSection={setCurrentSection} />} />
          <Route path="/bookshop" element={<BookShop activeSection={currentSection} onSelectSection={setCurrentSection} />} />
          <Route path="/childcare" element={<ChildCare activeSection={currentSection} onSelectSection={setCurrentSection} />} />
          <Route path="/socialboard" element={<SocialBoard activeSection={currentSection} onSelectSection={setCurrentSection} />} />

          {/* Departments */}
          <Route path="/departments" element={<OurDepartments activeSection={currentSection} onSelectSection={setCurrentSection} />} />
          <Route path="/our-departments" element={<OurDepartments activeSection={currentSection} onSelectSection={setCurrentSection} />} />

          {/* Publications */}
          <Route path="/publications" element={<OurPublications activeSection={currentSection} onSelectSection={setCurrentSection} />} />
          <Route path="/readings" element={<Readings activeSection={currentSection} onSelectSection={setCurrentSection} />} />

          {/* Contact */}
          <Route path="/contact" element={<ContactUs activeSection={currentSection} onSelectSection={setCurrentSection} />} />
          <Route path="/contact-us" element={<ContactUs activeSection={currentSection} onSelectSection={setCurrentSection} />} />
          <Route path="/get-in-touch" element={<ContactUs activeSection={currentSection} onSelectSection={setCurrentSection} />} />

          {/* Media */}
          <Route path="/live" element={<LiveStreaming activeSection={currentSection} onSelectSection={setCurrentSection} />} />
          <Route path="/gallery" element={<PhotoGallery activeSection={currentSection} onSelectSection={setCurrentSection} />} />

          {/* News & Results */}
          <Route path="/news" element={<NewsAndResults activeSection={currentSection} onSelectSection={setCurrentSection} />} />
          <Route path="/results" element={<NewsAndResults activeSection={currentSection} onSelectSection={setCurrentSection} />} />
          <Route path="/our-results" element={<NewsAndResults activeSection={currentSection} onSelectSection={setCurrentSection} />} />
          <Route path="/announcements" element={<NewsAndResults activeSection={currentSection} onSelectSection={setCurrentSection} />} />
          <Route path="/events" element={<NewsAndResults activeSection={currentSection} onSelectSection={setCurrentSection} />} />

          {/* Sitemap */}
          <Route path="/sitemap" element={<Sitemap activeSection={currentSection} onSelectSection={setCurrentSection} />} />

          {/* Home / Default */}
          <Route path="/home" element={<Home activeSection={currentSection} onSelectSection={setCurrentSection} />} />
          <Route path="/" element={<Home activeSection={currentSection} onSelectSection={setCurrentSection} />} />

          {/* Fallback Catch-All */}
          <Route path="*" element={<Home activeSection={currentSection} onSelectSection={setCurrentSection} />} />
        </Routes>
      </main>

      <Footer activeSection={currentSection} onSelectSection={setCurrentSection} />
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
